/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/imagesMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Images. */
var Images = /** @class */function () {
  /**
   * Create a Images.
   * @param {LabServicesClientContext} client Reference to the service client.
   */
  function Images(client) {
    this.client = client;
  }
  Images.prototype.listByLabPlan = function (resourceGroupName, labPlanName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labPlanName: labPlanName,
      options: options
    }, listByLabPlanOperationSpec, callback);
  };
  Images.prototype.get = function (resourceGroupName, labPlanName, imageName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labPlanName: labPlanName,
      imageName: imageName,
      options: options
    }, getOperationSpec, callback);
  };
  Images.prototype.createOrUpdate = function (body, resourceGroupName, labPlanName, imageName, options, callback) {
    return this.client.sendOperationRequest({
      body: body,
      resourceGroupName: resourceGroupName,
      labPlanName: labPlanName,
      imageName: imageName,
      options: options
    }, createOrUpdateOperationSpec, callback);
  };
  Images.prototype.update = function (resourceGroupName, labPlanName, imageName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labPlanName: labPlanName,
      imageName: imageName,
      options: options
    }, updateOperationSpec, callback);
  };
  Images.prototype.listByLabPlanNext = function (nextPageLink, options, callback) {
    return this.client.sendOperationRequest({
      nextPageLink: nextPageLink,
      options: options
    }, listByLabPlanNextOperationSpec, callback);
  };
  return Images;
}();
export { Images };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listByLabPlanOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labPlans/{labPlanName}/images",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labPlanName],
  queryParameters: [Parameters.apiVersion, Parameters.filter],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedImages
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var getOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labPlans/{labPlanName}/images/{imageName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labPlanName, Parameters.imageName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.Image
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var createOrUpdateOperationSpec = {
  httpMethod: "PUT",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labPlans/{labPlanName}/images/{imageName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labPlanName, Parameters.imageName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: __assign(__assign({}, Mappers.Image), {
      required: true
    })
  },
  responses: {
    200: {
      bodyMapper: Mappers.Image
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var updateOperationSpec = {
  httpMethod: "PATCH",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labPlans/{labPlanName}/images/{imageName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labPlanName, Parameters.imageName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: {
      enabledState: ["options", "enabledState"]
    },
    mapper: __assign(__assign({}, Mappers.ImageUpdate), {
      required: true
    })
  },
  responses: {
    200: {
      bodyMapper: Mappers.Image
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var listByLabPlanNextOperationSpec = {
  httpMethod: "GET",
  baseUrl: "https://management.azure.com",
  path: "{nextLink}",
  urlParameters: [Parameters.nextPageLink],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedImages
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};